export default __webpack_public_path__ + "static/media/dispatch-empty.c91c8f6f.svg";